export class ResolvingError extends ReferenceError {
  public readonly name = 'ResolvingError';
}
